export const TAB_STYLES = {
  base: 'rounded-none pb-[9px] !uppercase text-giveaway-text-subtle-light hover:!text-black border-b-transparent border-b-[3px]',
  get multi() {
    return this.base + ' ui-selected:border-giveaway-primary-subtle ui-selected:!text-giveaway-text-primary-dark'
  },
  active: '!border-b-giveaway-primary-subtle !border-b-[3px] !text-giveaway-text-primary-dark',
  disabled: '!opacity-80 cursor-not-allowed hover:!text-giveaway-subtle',
} as const

export const INTERSECTION_OBSERVER_CONFIG = {
  threshold: 0.2,
  rootMargin: '-50px 0px',
} as const

export const EXPERIMENT_KEY = 'young-washington-single-tab' as const

export const SCROLL_BEHAVIOR_CONFIG = {
  behavior: 'smooth' as const,
  block: 'start' as const,
}
